import Events from '@utilities/events/events'

const JS_HOOK_CLOSE_BTN = '[js-hook-alert-close]'
const hiddenClass = 'u-hidden'

class Alert {
  constructor(element) {
    this.element = element;
    this.closeButton = element.querySelector(JS_HOOK_CLOSE_BTN);
    this._isHidden = element.classList.contains(hiddenClass);

    this.bindEvents();
  }

  set isHidden(boolean) {
    this._isHidden = boolean;
  }

  get isHidden() {
    return this._isHidden;
  }

  /**
   * Bind all events
   */
  bindEvents() {
    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => {
        this.closeAlert();
      })
    }

    Events.$on(`alert[${this.element.id}]::close`, () => {
      this.closeAlert();
    })

    Events.$on(`alert::close`, () => {
      this.closeAlert();
    })
  }

  /**
   * Alerts the active classname of the toggle component and toggles aria attribute
   */
  closeAlert() {
    this.element.classList.add(hiddenClass);
    this.element.setAttribute('aria-hidden', true);
    this.isHidden = this.element.classList.contains(hiddenClass);
  }
}

export default Alert;
